import React from 'react'; 
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // <-- for navigation
import Axios from '../../../axios/axios';
import '../../Engineering/style.css'
const Catalogue = () => {
  const [brands, setBrands] = useState([]);
  const navigate = useNavigate(); // <-- initialize navigate

  const settings = {
    rows: 2,
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 6,
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 2000,
    nextArrow: (
      <div className="slick-arrow slick-next">
        <button className="btn btn-primary">
          <span className="fa fa-chevron-right"></span>
        </button>
      </div>
    ),
    prevArrow: (
      <div className="slick-arrow slick-prev">
        <button className="btn btn-primary">
          <span className="fa fa-chevron-left"></span>
        </button>
      </div>
    ),
    responsive: [
      { breakpoint: 1024, settings: { rows: 1, slidesToShow: 4 } },
      { breakpoint: 680, settings: { rows: 1, slidesToShow: 2 } },
      { breakpoint: 480, settings: { rows: 1, slidesToShow: 1 } },
    ],
  };

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await Axios.get('/type/engineering');
        setBrands(response.data);
      } catch (error) {
        console.error('Error fetching brands:', error);
      }
    };
    fetchBrands();
  }, []);

  // Navigate to EngineeringCategory with brandId as query param
  const handleBrandClick = (brandId) => {
  navigate(`/engineering/category?brandId=${brandId}`);
};

  return (
    <div className="d-flex justify-content-center align-items-center catelogue-container">
      <div className="shadow-sm p-3 mb-5 bg-white rounded Catalogue-container">
        <section>
          <h2 className="text-center mt-5 Layout-Title">SEARCH BY BRAND</h2>
          <Slider {...settings}>
            {brands.map((brand) => (
              <div className="slide-item" key={brand._id}>
                <div
                  className="slider-div text-center"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleBrandClick(brand._id)}
                >
                  <img
                    src={brand.images[0] || '/images/default.png'}
                    className="img-fluid w-50"
                    alt={brand.name}
                    style={{ objectFit: 'contain', height: '101px', width: '179px' }}
                  />
                  <p>{brand.name}</p>
                </div>
              </div>
            ))}
          </Slider>
        </section>
      </div>
    </div>
  );
};

export default Catalogue;
